import React from 'react';
import './contact.css';
import emailjs from 'emailjs-com';
// import LinkedIn from '../../svg/LinkedIn.svg'
import Linktree from '../../svg/Linktree.svg'
// import Octocat from '../../svg/octocat.svg'
import LottieAnimation from '../../Lottie';
import home from '../../Animations/Contact.json';

const Contact = () => {
    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_zk3nk53', e.target, 'user_Sz7r4sk53vv0fFsWRmZkH')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    }
    function getFriendlyMessage() {
        var nameString = 'fellow human'
        let messages = [
            `Hello ${nameString}, it's good to see you!`,
            `sup ${nameString}`,
            `hi there ${nameString}, you look awesome today!`,
            `hi there ${nameString}, you spectacular human being you!`,
            `you look awesome today ${nameString}!`,
            `hellllooooooo ${nameString}!`,
            `Hey ${nameString}, how's life?`,
            `Can you keep a secret, ${nameString}? You're my favorite!`,
            `Nothing to see here, ${nameString}.`,
            `Congratulations, ${nameString}! You've discovered the console ;)`,
            `have i told you lately that i love you, ${nameString}?`,
            `i knew you'd find this Easter egg eventually, ${nameString}...`,
        ]
        var randomMessage = messages[Math.floor(Math.random() * messages.length)];
        alert(randomMessage)
    }
    return (
        <div className="contact">
            {/* Space my-28 */}
            <section id='contact'>
                <header className='px-5 text-2xl font-bold pt-10'>
                    <h2 className="contact-me text-yellow-600">Contact Me</h2>
                    <p className='text-white text-base font-thin'>I'd love to hear your thoughts!</p>
                </header>
                <div className='md:mx-6 flex flex-col flex-wrap md:flex-row justify-between'>
                    <div className='md:w-6/12 md:px-0 p-5 my-5'>
                        <div>
                            <p className='text-white font-bold'>Siddharth Singh</p>
                            <p className='text-white font-thin'>Bhopal, India</p>
                            <a href='mailto: sidisadev@gmail.com' className='text-white rounded-md text-bold mt-3 inline-block border-gray-500'>
                                sidisadev@gmail.com
                            </a>
                        </div>
                        <div className='flex flex-row flex-wrap mt-5'>
                            <div className='mr-4'>
                                <a href='https://linktr.ee/STK_365' target='_blank' rel='noreferrer'>
                                    <span className='rounded-md text-white mb-2 flex flex-row items-end border border-gray-500 p-2 rounded-lg text-sm'>
                                        <img src={Linktree} alt='' width='25px' height='25px' className='icon-class mr-1' />
                                        Linktree
                                    </span>
                                </a>
                            </div>

                            <div className='mr-4'>
                                <button onClick={getFriendlyMessage}>
                                    <span className='rounded-md text-white mb-2 flex flex-row items-end border border-gray-500 p-2 rounded-lg text-sm'>
                                        <img src="https://drive.google.com/uc?id=19f6xD80kRMUG5RfH3__7yTupmG5cRYh4" alt='' width='25px' height='25px' className='icon-class mr-1' />
                                        ????????
                                    </span>
                                </button>
                            </div>

                            {/* <a href='https://codepen.io/Theelipan' target='_blank' rel='noreferrer'>
                                <span className='mb-2 flex flex-row items-end border border-gray-500 p-2 rounded-lg text-sm'>
                                    <img src='./images/icons/codepen.svg' alt='' width='24px' height='24px' className='mr-1' />
                                    CodePen
                                </span>
                            </a> */}
                        </div>
                    </div>

                    <div id="box-border" className='bg-gray-900 px-5 py-10 md:py-8 sm:p-8 my-2 md:rounded-lg shadow-lg  justify-between w-full  md:w-6/12'>
                        <form className='flex flex-col space-y-3 m-auto w-full' name='contact' method='post' onSubmit={sendEmail}>
                            <input type='hidden' name='form-name' value='contact' />

                            <label htmlFor='name' className="text-white">Name</label>
                            <input type='text' name='name' id='name' className='gradient pl-1 rounded' required></input>
                            <label htmlFor='email' className="text-white">Email</label>
                            <input type='email' name='email' id='email' className='gradient pl-1 rounded' required></input>
                            <label htmlFor='message' className="text-white">Message</label>
                            <textarea name='message' id='message' cols='25' rows='5' className='gradient pl-1 rounded' required></textarea>
                            <button type='submit' className='text-white border border-gray-500 p-2 rounded-lg items-center shadow-md button-class'>
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
                <div className='relative md:bottom-56 mr-auto ml-auto md:mr-auto md:ml-0 max-w-xs md:max-w-sm'>
                    <LottieAnimation lotti={home} />
                </div>
            </section>
        </div>
    );
};

export default Contact;
